import Vue from 'vue';
import store from '@/store';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import i18n from '@/i18n';

export const depositSlipsService = {
  getDepositSlips(paginationParams = null) {
    return Vue.axios
      .all([
        Vue.axios.get('deposit-slips', {
          params: {
            ...paginationParams
          }
        }),
        Vue.axios.get('deposit-slips/record-count')
      ])
      .then(
        Vue.axios.spread((slips, count) => {
          return { slips: slips.data, count: count.data };
        })
      );
  },

  async downloadDepositSlip(attachmentId, originalName) {
    let response;
    try {
      response = await Vue.axios({
        url: `/attachments/${attachmentId}/download`,
        method: 'GET',
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', originalName);
      document.body.appendChild(link);
      link.click();
      return response;
    } catch (e) {
      const status = e.status;
      let message;
      switch (status) {
        case 403:
          message = i18n.t('attachments.errors.forbiddenView');
          break;
        case 404:
          message = i18n.t('attachments.errors.notFound');
          break;
        default:
          message = i18n.t('attachments.errors.unknown', { status });
      }

      store.dispatch(TolErrorsActions.SetError, { message });
    }
  }
};
